import { UI } from "@/constants/ui-strings";
import { cn } from "@/lib";
import { ActionType } from "@/types";

type ActionsBlockProps<T> = {
  actions: ActionType<T>[];
  className?: string;
};

export function ActionsBlock<T>({ actions, className }: ActionsBlockProps<T>) {
  return (
    <section className={cn("flex items-center justify-end gap-2 md:gap-4", className)}>
      {actions.map(({ key, Component, props }) => {
        const componentProps = (props || {}) as unknown as T;
        if (!Component) {
          console.error(UI.errors.actionError(key), {
            key,
            Component,
            props,
          });
          return null;
        }
        return <Component {...componentProps} key={key} />;
      })}
    </section>
  );
}
